import React from 'react'
import { useNavigate } from 'react-router-dom'
import {
  NOTIFICATION_CLICK_MESSAGE,
  canNotify,
  registerNotificationWorker
} from 'shared/utils/notifications'

const askPermission = () => {
  try {
    void Notification.requestPermission()?.catch(() => undefined)
  } catch {
    // браузер требует жест пользователя — спросим по касанию
  }
}

// Разрешение на уведомления и воркер, который их показывает.
// Воркер нужен и на компьютере, и на телефоне: на телефоне другого способа нет
export const useBrowserNotifications = (isEnabled: boolean, isAskingPermission: boolean) => {
  const navigate = useNavigate()
  const navigateRef = React.useRef(navigate)

  React.useEffect(() => {
    navigateRef.current = navigate
  }, [navigate])

  React.useEffect(() => {
    if (!isEnabled || !canNotify()) return undefined

    void registerNotificationWorker()

    const onWorkerMessage = (event: MessageEvent) => {
      if (event.data?.type !== NOTIFICATION_CLICK_MESSAGE || !event.data?.url) return
      navigateRef.current(event.data.url)
    }
    navigator.serviceWorker?.addEventListener('message', onWorkerMessage)

    return () => {
      navigator.serviceWorker?.removeEventListener('message', onWorkerMessage)
    }
  }, [isEnabled])

  React.useEffect(() => {
    if (!isAskingPermission || !canNotify() || Notification.permission !== 'default') return undefined

    askPermission()

    // Запрос без жеста пользователя браузеры отклоняют молча,
    // поэтому повторяем его по первому касанию
    const ask = () => askPermission()
    window.addEventListener('pointerdown', ask, { once: true })

    return () => window.removeEventListener('pointerdown', ask)
  }, [isAskingPermission])
}
